import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomDialog from '@ui/components/common/Dialog';
import BDrawer from '@ui/components/common/BDrawer';
import { PrimaryGrid } from '@ui/components/common/Grid';
const VehiclesListDialog = ({ open, onClose, routeName, rows, vehicleCount }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const columns = [
        {
            field: 'vehicleNumberCarrier',
            headerName: t('events.eventDetails.routeTab.vehicleAndCarrier'),
            flex: 1.4,
            minWidth: 190,
            sortable: false,
            renderCell: (params) => (_jsxs(Box, { display: 'flex', flexDirection: 'column', children: [_jsx(Typography, { variant: 'body2', children: params.row.vehicleNumber }), _jsx(Typography, { variant: 'body2', color: 'text.secondary', children: params.row.carrier })] }))
        },
        {
            field: 'driverNumber',
            headerName: t('events.eventDetails.routeTab.driverNumber'),
            flex: 1,
            minWidth: 120,
            sortable: false
        },
        {
            field: 'seats',
            headerName: t('events.eventDetails.routeTab.seats'),
            flex: 0.8,
            minWidth: 100,
            sortable: false
        }
    ];
    const content = (_jsx(Box, { children: _jsx(PrimaryGrid, { columns: columns, rows: rows, showHeaderControls: false, showNewHeaderControls: false, noRowsText: t('events.eventDetails.routeTab.noVehiclesFound'), maxHeight: '360px' }) }));
    const actions = (_jsx(Box, { width: '100%', children: _jsx(Button, { variant: 'outlined', color: 'inherit', size: 'large', onClick: onClose, fullWidth: true, children: t('actions.close') }) }));
    const titleText = t('events.eventDetails.routeTab.routeVehiclesTitle', {
        routeName,
        count: vehicleCount ?? rows.length
    });
    if (isSmallScreen) {
        return (_jsx(BDrawer, { open: open, onClose: onClose, title: titleText, anchor: 'bottom', showBottomBar: true, dialogActions: actions, children: _jsx(Box, { sx: { p: 2 }, children: content }) }));
    }
    return (_jsx(CustomDialog, { open: open, onClose: onClose, titleWithIcon: titleText, titleIcon: '/assets/images/setting-task-icon.png', maxWidth: 'md', backgroundVariant: 'white', closeIcon: true, actions: actions, children: _jsx(Box, { p: 1.5, children: content }) }));
};
export default VehiclesListDialog;
